import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getRiskAssessmentResultFormConfig = () => {
  return {
    AssessmentId: {
      fieldId: 'AssessmentId',
      formLabel: t('assessmentResults.fields.Assessment'),
    },
    OversightAssessmentId: {
      fieldId: 'OversightAssessmentId',
      formLabel: t('assessmentResults.fields.OversightAssessment'),
    },
    InternalAuditReportId: {
      fieldId: 'InternalAuditReportId',
      formLabel: t('assessmentResults.fields.InternalAuditReport'),
    },
    RiskIds: {
      fieldId: 'RiskIds',
      formLabel: t('assessmentResults.fields.Risk'),
    },
    ControlType: {
      fieldId: 'ControlType',
      formLabel: t('assessmentResults.fields.ControlType'),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'assessmentResults.controlTypesCased',
      },
    },
    Likelihood: {
      fieldId: 'Likelihood',
      formLabel: t('assessmentResults.fields.Likelihood'),
      displayType: { displayType: 'rating', ratingKey: 'likelihood' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Impact: {
      fieldId: 'Impact',
      formLabel: t('assessmentResults.fields.Impact'),
      displayType: { displayType: 'rating', ratingKey: 'impact' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Rating: {
      fieldId: 'Rating',
      formLabel: t('assessmentResults.fields.Rating'),
      // the options for this are based on control type, which is problematic when adding condtions as we don't know the control type yet
    },
    Rationale: {
      fieldId: 'Rationale',
      formLabel: t('assessmentResults.fields.Rationale'),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    TestDate: {
      fieldId: 'TestDate',
      formLabel: t('assessmentResults.fields.TestDate'),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t('assessmentResults.fields.newFiles'),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
